import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SpreadsheetFileIcon = (props: IconProps) => (
  <Icon width="87px" height="77px" viewBox="0 0 87 77" {...props}>
    <rect width="18.636" height="8.889" x=".395" y=".37" rx="2" />
    <rect width="18.636" height="8.889" x=".395" y="17.407" rx="2" />
    <rect width="18.636" height="8.889" x=".395" y="34.444" rx="2" />
    <rect width="18.636" height="8.889" x=".395" y="51.481" rx="2" />
    <path d="M.395 70.519a2 2 0 0 1 2-2h14.636a2 2 0 0 1 2 2v4.888a2 2 0 0 1-2 2H2.395a2 2 0 0 1-2-2V70.52Z" />
    <rect width="18.636" height="8.889" x="23.42" y=".37" rx="2" />
    <rect width="18.636" height="8.889" x="23.42" y="17.407" rx="2" />
    <rect width="18.636" height="8.889" x="23.42" y="34.444" rx="2" />
    <rect width="18.636" height="8.889" x="23.42" y="51.481" rx="2" />
    <path d="M23.42 70.519a2 2 0 0 1 2-2h14.636a2 2 0 0 1 2 2v4.888a2 2 0 0 1-2 2H25.42a2 2 0 0 1-2-2V70.52Z" />
    <rect width="18.636" height="8.889" x="46.444" y=".37" rx="2" />
    <rect width="18.636" height="8.889" x="46.444" y="17.407" rx="2" />
    <rect width="18.636" height="8.889" x="46.444" y="34.444" rx="2" />
    <rect width="18.636" height="8.889" x="46.444" y="51.481" rx="2" />
    <path d="M46.444 70.519a2 2 0 0 1 2-2H63.08a2 2 0 0 1 2 2v4.888a2 2 0 0 1-2 2H48.444a2 2 0 0 1-2-2V70.52Z" />
    <rect width="18.636" height="8.889" x="69.469" y=".37" rx="2" />
    <rect width="18.636" height="8.889" x="69.469" y="17.407" rx="2" />
    <rect width="18.636" height="8.889" x="69.469" y="34.444" rx="2" />
    <rect width="18.636" height="8.889" x="69.469" y="51.481" rx="2" />
    <path d="M69.469 70.519a2 2 0 0 1 2-2h14.636a2 2 0 0 1 2 2v4.888a2 2 0 0 1-2 2H71.469a2 2 0 0 1-2-2V70.52Z" />
  </Icon>
);

export default memo(SpreadsheetFileIcon);
